"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BACK_PAY = exports.BONUS = exports.VACATION = exports.HOLIDAY = exports.COMMISSION = exports.OVERTIME = exports.WAGES = void 0;
exports.WAGES = "wages";
exports.OVERTIME = "overtime";
exports.COMMISSION = "commission";
exports.HOLIDAY = "holiday";
exports.VACATION = "vacation";
exports.BONUS = "bonus";
exports.BACK_PAY = "backPay";